const getRatios = (count) => {
  const total = count.reduce((sum, c) => sum + c, 0);
  const dist = count.map((c) => c / total);
  return dist;
};
export {
  getRatios
};
//# sourceMappingURL=index122.js.map
